/* Noche cart drawer + free gift sync (Oct 2026).
   - Wraps window.fetch and XMLHttpRequest: after any successful POST to /cart/add|change|update|clear made by
     the theme or an app, it syncs the free gift lines, refreshes the cart, and opens the drawer after an add.
   - Gifts are separate hidden products (tag nyd-gift). Shopify automatic discounts make them $0 at checkout only
     when the cart qualifies, so this script only decides whether the gift line is IN the cart.
   - CFG must match snippets/nyd-cart-core.liquid and the two automatic discounts in Shopify admin. */
(function () {
  'use strict';
  if (window.NYDCart || !window.fetch || !window.Promise) return;

  var CFG = {
    gifts: [
      { vid: 50667625906241, min: 6000 }, // Free Gift: Soothing Foot Cream at $60
      { vid: 50667626430529, min: 7500 }  // Free Gift: Ocean Caviar Eye Contour at $75
    ],
    sections: ['nyd-cart-drawer'],
    maxWait: 4000
  };
  var GIFT_IDS = CFG.gifts.map(function (g) { return g.vid; });
  var RE = /\/cart\/(add|change|update|clear)(\.js)?$/;
  var JSONH = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var of = window.fetch.bind(window);
  var d = document, q = Promise.resolve(), lastOpener = null;

  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function post(u, b) { return of(u, { method: 'POST', credentials: 'same-origin', headers: JSONH, body: JSON.stringify(b) }); }
  function getCart() { return of('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function onCartPage() { return /^\/cart\/?$/.test(location.pathname); }
  function drawer() { return $('[data-nyd-drawer]'); }

  /* ---------- free gift sync ---------- */
  function run() {
    return getCart().then(function (c) {
      var qual = 0, attrs = c.attributes || {}, have = {}, updates = {}, adds = [], changed = false;
      (c.items || []).forEach(function (it) {
        if (GIFT_IDS.indexOf(it.variant_id) > -1) { (have[it.variant_id] = have[it.variant_id] || []).push(it); }
        else { qual += it.original_line_price; }
      });
      CFG.gifts.forEach(function (g) {
        var want = qual >= g.min && attrs['_nyd_no_' + g.vid] !== '1';
        var lines = have[g.vid] || [];
        if (want && !lines.length) { adds.push({ id: g.vid, quantity: 1, properties: { _nyd_gift: '1' } }); }
        lines.forEach(function (it, i) {
          var target = (want && i === 0) ? 1 : 0;
          if (it.quantity !== target) { updates[it.key] = target; changed = true; }
        });
      });
      var p = Promise.resolve();
      if (changed) p = p.then(function () { return post('/cart/update.js', { updates: updates }); });
      if (adds.length) { changed = true; p = p.then(function () { return post('/cart/add.js', { items: adds }); }); }
      return p.then(function () { return changed; });
    }).catch(function () { return false; });
  }
  /* serialized so two quick cart calls never race */
  function sync() { var p = q.then(run); q = p.catch(function () {}); return p; }

  /* ---------- rendering ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n > 0 ? n : ''; });
    $$('[data-cart-count-bubble]').forEach(function (el) { el.classList.toggle('hide', n < 1); });
    $$('[data-nyd-n]').forEach(function (el) { el.textContent = '(' + n + ')'; });
  }
  function render() {
    var ids = [];
    if (drawer()) ids.push('nyd-cart-drawer');
    if ($('[data-nyd-page]')) ids.push('nyd-cart-page');
    var jobs = [getCart().then(function (c) { setCount(c.item_count); }).catch(function () {})];
    if (ids.length) {
      jobs.push(of(location.pathname + '?sections=' + ids.join(','), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (s) {
          ids.forEach(function (id) {
            if (!s[id]) return;
            var tmp = d.createElement('div'); tmp.innerHTML = s[id];
            var nb = $('[data-nyd-body]', tmp);
            var host = id === 'nyd-cart-drawer' ? drawer() : $('[data-nyd-page]');
            var ob = host && $('[data-nyd-body]', host);
            if (nb && ob) ob.innerHTML = nb.innerHTML;
          });
        }).catch(function () {}));
    }
    /* always clear the busy state: the body element itself is kept, only its contents are swapped */
    return Promise.all(jobs).then(unbusy, unbusy);
  }
  function unbusy() { $$('[data-nyd-body].is-busy').forEach(function (b) { b.classList.remove('is-busy'); }); }
  function refresh() { return sync().then(render); }
  function busy(el, on) {
    var b = el && el.closest('[data-nyd-body]'); if (!b) return;
    b.classList.toggle('is-busy', !!on);
    /* safety net: never leave the cart frozen if a request hangs */
    if (on) setTimeout(function () { b.classList.remove('is-busy'); }, 8000);
  }
  function say(msg) { var l = $('[data-nyd-live]'); if (l) { l.textContent = ''; setTimeout(function () { l.textContent = msg; }, 50); } }

  /* ---------- drawer ---------- */
  function openCart(opener) {
    var dl = drawer();
    if (!dl || onCartPage()) { if (!onCartPage()) location.href = '/cart'; else render(); return; }
    lastOpener = opener || d.activeElement;
    dl.hidden = false;
    d.documentElement.classList.add('nydc-lock');
    requestAnimationFrame(function () { dl.classList.add('is-open'); });
    setTimeout(function () { var t = $('#nydc-title'); if (t) t.focus(); }, 60);
    refresh();
  }
  function closeCart() {
    var dl = drawer(); if (!dl || dl.hidden) return;
    dl.classList.remove('is-open');
    d.documentElement.classList.remove('nydc-lock');
    setTimeout(function () { dl.hidden = true; }, 250);
    if (lastOpener && lastOpener.focus) lastOpener.focus();
  }

  /* ---------- watch cart calls made by the theme and apps ---------- */
  var internal = 0;
  function afterExternal(path) {
    var isAdd = /\/cart\/add/.test(path);
    var t = new Promise(function (r) { setTimeout(r, CFG.maxWait); });
    return Promise.race([sync(), t]).then(function () {
      if (isAdd && drawer() && !onCartPage()) openCart();
      else render();
    });
  }
  function pathOf(u) { return String(u || '').replace(/^https?:\/\/[^\/]+/i, '').split(/[?#]/)[0]; }

  window.fetch = function (input, init) {
    var p = of(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var m = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var path = pathOf(url);
      if (internal || m !== 'POST' || !RE.test(path)) return p;
      return p.then(function (res) {
        if (res && res.ok) afterExternal(path);
        return res;
      });
    } catch (e) { return p; }
  };
  (function () {
    var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this._nyd = { m: String(m).toUpperCase(), p: pathOf(u) }; return XO.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var x = this, i = x._nyd;
      if (i && i.m === 'POST' && RE.test(i.p)) {
        x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) afterExternal(i.p); });
      }
      return XS.apply(this, arguments);
    };
  })();

  /* ---------- our own buttons ---------- */
  function mine(fn) { internal++; return Promise.resolve().then(fn).then(function (v) { internal--; return v; }, function (e) { internal--; throw e; }); }

  d.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    var close = t.closest('[data-nyd-close]');
    if (close) { e.preventDefault(); closeCart(); return; }

    var cartLink = t.closest('a.site-header__cart, a[href="/cart"].site-header__icon');
    if (cartLink && drawer() && !onCartPage()) { e.preventDefault(); openCart(cartLink); return; }

    var qtyBtn = t.closest('[data-nyd-qty]');
    if (qtyBtn) {
      e.preventDefault(); busy(qtyBtn, true);
      var qty = parseInt(qtyBtn.getAttribute('data-nyd-qty'), 10) || 0;
      mine(function () { return post('/cart/change.js', { id: qtyBtn.getAttribute('data-key'), quantity: Math.max(0, qty) }); })
        .then(refresh).then(function () { say(qty === 0 ? 'Item removed' : 'Quantity updated'); })
        .catch(function () { render(); });
      return;
    }

    var addBtn = t.closest('[data-nyd-add]');
    if (addBtn) {
      e.preventDefault(); busy(addBtn, true);
      mine(function () {
        return post('/cart/add.js', { items: [{ id: parseInt(addBtn.getAttribute('data-nyd-add'), 10), quantity: 1, properties: { _nyd_source: addBtn.getAttribute('data-nyd-src') || 'cart' } }] });
      }).then(refresh).then(function () { say('Added to cart'); }).catch(function () { render(); });
      return;
    }

    var dec = t.closest('[data-nyd-decline]');
    if (dec) {
      e.preventDefault(); busy(dec, true);
      var attrs = {}; attrs['_nyd_no_' + dec.getAttribute('data-nyd-decline')] = '1';
      var upd = {}; upd[dec.getAttribute('data-key')] = 0;
      mine(function () { return post('/cart/update.js', { attributes: attrs, updates: upd }); })
        .then(render).then(function () { say('Free gift removed'); }).catch(function () { render(); });
    }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  /* make sure gift lines are right before the customer leaves for checkout */
  d.addEventListener('submit', function (e) {
    var f = e.target, btn = e.submitter;
    if (!f.closest || !f.closest('[data-nyd-body]') || f._nydOk) return;
    e.preventDefault();
    if (btn) btn.setAttribute('aria-busy', 'true');
    var t = new Promise(function (r) { setTimeout(r, CFG.maxWait); });
    Promise.race([sync(), t]).then(function () {
      f._nydOk = true;
      var h = d.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = '1'; f.appendChild(h);
      f.submit();
    });
  });

  /* cart page: correct gifts on load (e.g. after a discount code changed the total) */
  if (onCartPage() && $('[data-nyd-page]')) { sync().then(function (ch) { if (ch) render(); }); }

  window.NYDCart = { open: openCart, close: closeCart, sync: sync, refresh: refresh };
})();
